/* eslint-disable */ import { attributeSelectionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { LegsThickness } from '../model/index.js';
export const legsWithThicknessComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'legThickness', true).withAlias('LegsWithThickness').attach(memoEval((self)=>[
            self.legThickness,
            self.$legThicknessOptions
        ], (legThickness, $legThicknessOptions)=>({
            value: legThickness,
            options: $legThicknessOptions
        })), (state)=>{
        LegsThickness.assert(state.value);
        return {
            legThickness: state.value
        };
    })
];

//# sourceMappingURL=legs-with-thickness.js.map